import config from "../config";
import {User} from "../models/user";

function callInfinitoolsLogin(path: string, keepPage: boolean = false) {
  const s = config.apiHost.includes('localhost') ? "" : "s";

  const keepQuery = keepPage ? `?returnTo=${encodeURIComponent(window.location.pathname)}` : '';

  const url = `http${s}://auth.${config.authFrontHost}/${path}?externalApp=ketnutri&successPath=${encodeURIComponent(`http${s}://${config.baseHost}/loginSucceeded${keepQuery}`)}&cancelPath=${encodeURIComponent(`http${s}://${config.baseHost}//`)}`;
  window.location.assign(url)
}

export const AuthService = {
  logIn: () => callInfinitoolsLogin("login", true),
  register: () => callInfinitoolsLogin("register", true),
  logOut: () => callInfinitoolsLogin("logout"),
  hasPermission: (user: User | null, requiredPermission: string) => {
    if (user === null) return false;
    const segments = requiredPermission.split(".");

    if (user.permissions == null) return false;

    let activePermissions = user.permissions;

    for (let i = 0; i < segments.length; i++) {
      let segment = segments[i];

      activePermissions = activePermissions.filter(p => p.startsWith(segment)).map(p => {
        const sp = p.split(".", 2);
        return sp.length === 2 ? sp[1] : "";
      });

      if (activePermissions.length === 0)
        return false;

      if (activePermissions.filter(p => p === "*" || p === '').length > 0)
        return true;
    }

    return true;
  }

}
